import Box from 'common/components/Box';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import Text from 'common/components/Text';
import { Container, AuthorContainer } from './author.style';
const Author = ({
  data,
  imageStyle,
  styleAuthor,
  boxPublishedDate,
  datePublished,
  styleAuthorType,
  author,
}) => {
  const published_date = new Date(data.published_date);
  const formatedDate = format(published_date, 'MMMM dd, yyyy');
  const authorBio = author?.data?.authorbio[0]?.text ?? '';
  const authorName = author?.data?.name[0]?.text ?? '';
  const authorProfil = author?.data?.profil?.url ?? '';

  return (
    <Container>
      <AuthorContainer>
        <Box style={{ width: '100%' }}>
          <Text style={styleAuthorType} content={data.author.type} />
          <Text as='h4' content={authorName} style={styleAuthor} />
          <Box>{authorBio}</Box>
        </Box>
        <Box>
          <img src={authorProfil} style={imageStyle} />
        </Box>
      </AuthorContainer>
      <Box style={boxPublishedDate}>
        <Text mt={4} content={'Published'} />
        <Text mt={4} ml={4} style={datePublished} content={formatedDate} />
      </Box>
    </Container>
  );
};
Author.propTypes = {
  imageStyle: PropTypes.object,
  boxPublishedDate: PropTypes.object,
  styleAuthor: PropTypes.object,
  datePublished: PropTypes.object,
  styleAuthorType: PropTypes.object,
  button: PropTypes.object,
};
Author.defaultProps = {
  button: {
    type: 'button',
    fontSize: '18px',
    fontWeight: '700',
    borderRadius: '4px',
    pl: '15px',
    pr: '15px',
    color: 'white',
    width: '100%',
    colors: 'primaryWithBg',
    minHeight: 'auto',
    height: '40px',
  },
  datePublished: {
    textTransform: 'capitalize',
  },
  styleAuthorType: {
    textTransform: 'capitalize',
    letterSpacing: '.16em',
  },
  boxPublishedDate: {
    width: '100%',
    textTransform: 'uppercase',
    letterSpacing: '.08em',
    display: 'flex',
    fontWeight: 500,
    marginBottom: '30px',
    height: '2rem',
    color: '#484848',
  },
  styleAuthor: {
    textTransform: 'capitalize',
    letterSpacing: '.08em',
    fontWeight: 700,
  },
  imageStyle: {
    width: 90,
    height: 90,
    borderRadius: '50%',
  },
};
export default Author;
